export const API_URL = process.env.REACT_APP_API_URL;
export const IPFS_URL = process.env.REACT_APP_IPFS_URL;
export const NFT_CONTRACT = process.env.REACT_APP_NFT_CONTRACT;
export const EXPLORER_URL = process.env.REACT_APP_EXPLORER_URL;
export const SYMBOL = process.env.REACT_APP_SYMBOL;
